import { Search } from 'lucide-react';
import { useState } from 'react';

interface Props {
  initial: string;
  onSubmit: (q: string) => void;
}

export function SearchBar({ initial, onSubmit }: Props) {
  const [value, setValue] = useState(initial);
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(value.trim());
      }}
    >
      <div className="relative">
        <Search
          className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5"
          aria-hidden
        />
        <input
          type="search"
          aria-label="Search establishments"
          placeholder="Search by name or address..."
          value={value}
          onChange={(e) => {
            const next = e.target.value;
            setValue(next);
            if (next === '' && value !== '') {
              onSubmit('');
            }
          }}
          className="w-full !pl-12 !pr-4 sm:!pr-32 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-snhd-primary focus:border-transparent transition-all text-gray-900 placeholder-gray-400"
        />
        <button
          type="submit"
          className="mt-2 sm:mt-0 w-full sm:w-auto inline-flex justify-center items-center sm:absolute sm:right-2 sm:top-1/2 sm:-translate-y-1/2 px-4 py-3 sm:py-2 bg-snhd-primary text-white rounded-lg text-sm font-medium hover:bg-snhd-primary-hover transition-colors"
        >
          Search
        </button>
      </div>
    </form>
  );
}
